module.exports = __webpack_public_path__ + "img/Certifier2.f7cbb839.png";